import { Patch, uploadMedia } from "axios/AxiosFunctions";
import { Button } from "components/Core/Button";
import { DropDown } from "components/Core/DropDown";
import { Input } from "components/Core/Input";
import { ProfileWithEditButton } from "components/Core/ProfileWithEditButton";
import SideBarSkeleton from "components/Core/SideBarSkeleton";
import HeadingComponent from "components/HeadingComponent";
import { BaseURL } from "config/apiUrl";
import { cycleFormatOptions } from "constant/data";
import {
  apiHeader,
  camelCaseToLower,
  RenderToast,
} from "helper/HelperFunction";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateUser } from "store/auth/authSlice";
import classes from "./SchoolSettings.module.css";

const SchoolSettings = () => {
  const { user, access_token } = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [schoolName, setSchoolName] = useState(user?.school?.name);
  const [cycleFormat, setCycleFormat] = useState(
    cycleFormatOptions?.find(
      (option) => option.value === user?.school?.cycleFormat,
    ),
  );
  const [photo, setPhoto] = useState(user?.school?.image);
  const dispatch = useDispatch();

  const handleValidation = () => {
    let params = {
      image: photo,
      schoolName,
      cycleFormat: cycleFormat?.value,
    };
    for (let key in params) {
      if (!params[key]) {
        return RenderToast(
          "error",
          `Please fill the ${camelCaseToLower(key)} field!`,
        );
      }
    }
    handlePost(params);
  };

  const handlePost = async (data) => {
    setLoading("postLoading");
    const URL = BaseURL(`schools`);
    const response = await Patch(URL, data, apiHeader(access_token));
    if (response) {
      dispatch(
        updateUser({
          ...user,
          school: response?.data,
        }),
      );
      RenderToast("success", "School updated successfully");
    }
    setLoading(false);
  };

  const handleImageUpload = async (image) => {
    setLoading("imageUpload");
    const imageKey = await uploadMedia([image], access_token);
    if (imageKey !== undefined) {
      setPhoto(imageKey[0]);
    }
    setLoading(false);
  };

  return (
    <SideBarSkeleton
      headerHeading={<HeadingComponent heading={"School Settings"} />}
    >
      <div className={classes.profileSettings}>
        <div className={classes.header}>
          <ProfileWithEditButton
            updateImage={photo}
            setUpdateImage={(image) => {
              setPhoto(image);
              handleImageUpload(image);
            }}
            isEdit={true}
            loader={loading === "imageUpload"}
          />
        </div>

        <div className={classes.profileFrom}>
          <Input
            label={"School Name"}
            placeholder={"Enter School Name"}
            value={schoolName}
            setter={setSchoolName}
          />
          <DropDown
            options={cycleFormatOptions}
            label={"Cycle Format"}
            placeholder={"Select Cycle Format"}
            value={cycleFormat}
            setter={setCycleFormat}
          />
          <Input
            label={"School Email"}
            placeholder={"Enter Email"}
            value={user?.school?.primaryEmail}
            setter={() => {}}
            disabled={true}
          />
          <div className={classes.profileFromButtons}>
            <Button
              label={loading === "postLoading" ? "Wait..." : "Save"}
              disabled={loading}
              onClick={handleValidation}
            />
            <Button
              label={"Cancel"}
              onClick={() => navigate(-1)}
              variant="bordered"
              disabled={loading}
            />
          </div>
        </div>
      </div>
    </SideBarSkeleton>
  );
};

export default SchoolSettings;
